import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { ReactCookieProps } from "react-cookie";
import ScrollToTop from "../../hooks/scrollToTop";
import {
  getAxeptioCookieManager,
  getMatomoAnalyticsManager,
} from "../../services/Config";
import IFooter from "../Footer";
import IHeader from "../Header";
import MetaDatas from "../MetaDatas";
import styles from "./styles";

interface Props {
  children: JSX.Element[] | JSX.Element;
  title?: string;
  variant?: boolean;
  // cookies: Cookies;
  noFollow?: boolean;
}

function Layout({
  children,
  title,
  variant,
  // cookies,
  noFollow,
}: Props & ReactCookieProps) {
  const tagManager = getMatomoAnalyticsManager();
  const idAxeptio = getAxeptioCookieManager();
  useEffect(() => {
    if (idAxeptio) {
      window.axeptioSettings = {
        clientId: idAxeptio,
        jsonCookieName: "vertulooCookiesIsCheck",
        userCookiesDuration: 180,
      };
      const element = document.querySelector("body");
      const script = document.createElement("script");
      script.src = "https://static.axept.io/sdk-slim.js";
      script.integrity =
        "sha384-vClxL/c4by9yNX+YUc7JFTSlU4ftvzM0aBZ6xWqSlQO8Z54V+/xtU5HrHSSKFFm0";
      script.async = true;
      element?.appendChild(script);
      return () => {
        element?.removeChild(script);
      };
    }
  }, []);

  const [displayMatomo, setDisplayMatomo] = useState<boolean>(false);
  window._axcb = window._axcb || [];
  window._axcb.push((sdk: any) => {
    sdk.on("cookies:complete", (choices: any) => {
      if (choices.Matomo && !displayMatomo) {
        setDisplayMatomo(true);
      }
    });
  });
  return (
    <>
      <MetaDatas
        title={title}
        noFollow={noFollow}
        matomoTag={tagManager}
        matomoTrackingEnabled={displayMatomo}
      />
      <ScrollToTop />
      <IHeader />
      <Box
        component={"main"}
        sx={styles}
        className={`layout ${variant ? "full" : ""}`}
      >
        {children}
      </Box>
      <IFooter />
    </>
  );
}

export default Layout;
